import React from 'react';
import StartButton from '@/components/site/StartButton';
import GoldText from '@/components/site/GoldText';
import AssistantWorkbench from './AssistantWorkbench';

const promises = ['Start with one workflow.', 'Test it in your business.', 'Build from what works.'];

const Hero = () => (
  <section aria-labelledby="hero-title" className="relative overflow-hidden">
    <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 pb-20 pt-16 sm:px-6 md:pt-24 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:pb-24">
      <div className="reveal">
        <p className="eyebrow">AI assistants. Real business workflows.</p>
        <h1 id="hero-title" className="mt-5 text-[clamp(3rem,6.4vw,5.75rem)] leading-none">
          Put AI to work.
          <br />
          <GoldText>Start with one assistant.</GoldText>
        </h1>
        <p className="mt-7 max-w-[35rem] text-[1.19rem] leading-relaxed text-mist">
          Turn a repetitive business task into a focused AI workflow. GoldCrusade helps you{' '}
          <b className="font-medium text-softwhite">identify</b> the opportunity,{' '}
          <b className="font-medium text-softwhite">build</b> the assistant, and{' '}
          <b className="font-medium text-softwhite">evaluate</b> what changes.
        </p>
        <ul className="mt-6 flex flex-wrap font-mono text-xs uppercase tracking-[0.08em]">
          {promises.map((p) => (
            <li
              key={p}
              className="w-full py-1 sm:mr-3.5 sm:w-auto sm:border-r sm:border-rule2 sm:py-1.5 sm:pr-3.5 sm:last:mr-0 sm:last:border-r-0"
            >
              <span className="gold-shine">{p}</span>
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <StartButton size="lg" />
          <a href="#demo" className="gc-btn gc-btn-lg">
            Explore the demo
          </a>
        </div>
        <p className="mt-6 text-sm text-mist">
          <span className="text-softwhite">Free discovery call. No commitment.</span>
          <br />
          Scope and costs are confirmed before you commit to a pilot.
        </p>
      </div>

      <div className="reveal">
        <AssistantWorkbench />
      </div>
    </div>
  </section>
);

export default Hero;
